
export const SOCIALS = {
  instagram: {
    isLink: true
  },
  snapchat: {
    isLink: true
  },
  twitch: {
    isLink: true
  },
  discord: {
    isLink: false
  },
  tiktok: {
    isLink: true
  },
  youtube: {
    isLink: true
  },
  facebook: {
    isLink: true
  },
  linkedin: {
    isLink: true
  },
  bluesky: {
    isLink: true
  }
}